// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__dCQK4","info":"PatientInfo_info__39sVS"};